import { HeaderBaseItem } from 'typings/configs';

const CLASSIFIED_LINKS = ['/nedvizhimost/kupit-kvartiru/', '/nedvizhimost/snyat-kvartiru/', '/novostroyki/'];

const comparePathProps = (pathname: string, props: { path: string; exact?: boolean }): boolean => {
    if (props.exact) {
        return pathname === props.path;
    }
    return props.path !== '/' && pathname?.startsWith(props.path);
};

// Так как произошел переезд на региональные ссылки,
// то в url и path могут быть абсолютными и простой матч по ним с pathname не сработает
const extractItemPathname = (item?: HeaderBaseItem) => {
    const itemHref = item?.url || item?.path;
    return itemHref?.startsWith('http') ? new URL(itemHref).pathname : itemHref;
};

// Так как ссылки на классфаийд в конфиге хедера захардкожены через /moskva/{CLASSIFIED_LINKS},
// но pathname может быть /sankt-peterburg/{CLASSIFIED_LINKS},
// то не обходимо делать проверку на наличие одной из захардкоженной подстроки CLASSIFIED_LINKS,
// чтобы корректно подсветить пункт "Поиск" в хедере
const compareClassifiedPathname = (pathname?: string, href?: string) => {
    const classifiedLink = CLASSIFIED_LINKS.find((link) => href?.includes(link));
    return classifiedLink && pathname?.includes(classifiedLink);
};

export const comparePathname = (pathname?: string, item?: HeaderBaseItem) => {
    if (!pathname) return false;

    if (item?.activeRoute) {
        const routes = Array.isArray(item.activeRoute) ? item.activeRoute : [item.activeRoute];

        return routes.some((route) => new RegExp(route).test(pathname));
    }

    const itemPathname = extractItemPathname(item);

    if (!itemPathname) {
        return false;
    }

    return (
        compareClassifiedPathname(pathname, itemPathname) ||
        comparePathProps(pathname, { path: itemPathname, exact: item?.exact })
    );
};
